// Angular
import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../../../provider/auth/auth.service';

@Component({
  selector: 'kt-forgot-password',
  templateUrl: './forgot-password.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  // Public params
  forgotPasswordForm: FormGroup;
  loading = false;
  error = false;

  private subs: Subscription[] = [];

  constructor(private authService: AuthService,
              private translate: TranslateService,
              private router: Router,
              private fb: FormBuilder,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    const sub = this.authService.forgotPasswordSuccess.subscribe((data) => {
      if (data == true) {
        this.router.navigateByUrl('/auth/login').then();
        this.authService.forgotPasswordSuccess.next(undefined);
        this.error = false;
      } else if (data == false) {
        this.loading = false;
        this.cdr.markForCheck();
        this.error = true;
      }
    });
    this.subs.push(sub);

    this.initRegistrationForm();
  }

  ngOnDestroy(): void {
    this.subs.forEach(x => x.unsubscribe);
    this.loading = false;
  }

  initRegistrationForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.email,
        Validators.minLength(8),
        Validators.maxLength(50) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
      ])
      ]
    });
  }

  submit() {
    const controls = this.forgotPasswordForm.controls;
    /** check form */
    if (this.forgotPasswordForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }

    this.loading = true;
    const email = controls['email'].value;
    this.authService.forgotPassword(email);
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.forgotPasswordForm.controls[controlName];
    if (!control) {
      return false;
    }

    return control.hasError(validationType) && (control.dirty || control.touched);
  }
}
